<template>
    <v-row>
        <v-col>
            <v-row>
                <v-col>    
                    <v-skeleton-loader
                        type="text"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row>
                <v-col>    
                    <v-skeleton-loader
                        type="text"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row>
                <v-col>    
                    <v-skeleton-loader
                        type="text"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row>
                <v-col>    
                    <v-skeleton-loader
                        type="text"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row>
                <v-col>    
                    <v-skeleton-loader
                        type="text"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "ItemLoader"
}
</script>

<style>

</style>